module.exports = __webpack_public_path__ + "img/desc.ad73dbe6.png";